import React, { useState, useEffect } from 'react';
import { Box } from '@material-ui/core';
import Radio from '@material-ui/core/Radio';
import {
  // TextField,
  // FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  // MenuItem,
  // Checkbox,
  useTheme,
} from '@material-ui/core';
import { Controller } from 'react-hook-form';
import { useIntl } from 'umi';
import MessageML from '@/components/MessageML/index';
import webStorage from '@/utils/storageManager';
import NoticedStyled from './NoticedStyled';

const Noticed = (props) => {
  const userAuths = webStorage.get('USER')?.authorities;
  const isMenuEmailMktg = userAuths.includes('MENU_EMAIL_MKTG');
  //关于国际化
  const intl = useIntl();
  const { formatMessage } = intl;
  const { status, setSelectedNoticeChannels, activityGroupDetail, tenantId } =
    props;
  const [openSMS, setOpenSMS] = useState(false);
  const [openWechat, setOpenWechat] = useState(false);
  const [openMMS, setOpenMMS] = useState(false);
  const [openEmail, setOpenEmail] = useState(false);
  const [openLine, setOpenLine] = useState(false);
  //模板消息
  const [noticeChannels, setNoticeChannels] = useState([
    {
      checked: false,
      msgId: '',
      msgContent: '',
      type: '4',
    },
    {
      checked: false,
      msgId: '',
      msgContent: '',
      type: '2',
    },
    {
      checked: false,
      msgId: '',
      msgContent: '',
      type: '1',
    },
    {
      checked: false,
      emailId: '',
      emailContent: '',
      type: '5',
    },
    {
      checked: false,
      lineId: '',
      lineContent: '',
      type: '6',
    },
  ]);
  let wechatInfoItem = activityGroupDetail?.noticeChannels?.filter(
    (i) => i.type === '2',
  );
  let mmsInfoItem = activityGroupDetail?.noticeChannels?.filter(
    (i) => i.type === '4',
  );
  let msgInfoItem = activityGroupDetail?.noticeChannels?.filter(
    (i) => i.type === '1',
  );
  let emailInfoItem = activityGroupDetail?.noticeChannels?.filter(
    (i) => i.type === '5',
  );
  let lineInfoItem = activityGroupDetail?.noticeChannels?.filter(
    (i) => i.type === '6',
  );
  const { control } = props;
  const theme = useTheme();

  //关于编辑或预览初始给模板消息赋值
  useEffect(() => {
    if (activityGroupDetail?.noticeChannels) {
      const receiveNoticeChannels = activityGroupDetail?.noticeChannels;
      const editNoticeChannels = receiveNoticeChannels.map((item) => {
        return { checked: true, ...item };
      });
      // let array = [];
      const newNoticeChannels = noticeChannels?.map((currentValue) => {
        let obj;
        let type = currentValue.type;
        const channel = editNoticeChannels.find((i) => i.type === type);
        if (channel) {
          obj = channel;
        } else {
          obj = currentValue;
        }
        return obj;
      });
      setNoticeChannels(newNoticeChannels);
      const wechatInfo = receiveNoticeChannels.filter((i) => i.type === '2')[0];
      const msgInfo = receiveNoticeChannels.filter((i) => i.type === '1')[0];
      const mmsInfo = receiveNoticeChannels.filter((i) => i.type === '4')[0];
      const emailInfo = receiveNoticeChannels.filter((i) => i.type === '5')[0];
      const lineInfo = receiveNoticeChannels.filter((i) => i.type === '6')[0];
      if (wechatInfo) {
        setVxChecked(true);
        setWechatContent(wechatInfo?.msgContent);
        if (wechatInfo.msgId) {
          setWechatId(Number(wechatInfo?.msgId));
        }
      }
      if (msgInfo) {
        setMsgChecked(true);
        setMsgContent(msgInfo?.msgContent);
        if (msgInfo.msgId) {
          setMsgId(Number(msgInfo?.msgId));
        }
      }
      if (mmsInfo) {
        setMmsChecked(true);
        setMmsContent(mmsInfo?.msgContent);
        if (mmsInfo.msgId) {
          setMmsId(Number(mmsInfo?.msgId));
        }
      }
      if (emailInfo) {
        setEmailChecked(true);
        setEmailContent(emailInfo?.msgContent);
        if (emailInfo.msgId) {
          setEmailId(Number(emailInfo?.msgId));
        }
      }

      if (lineInfo) {
        setLineChecked(true);
        setLineContent(lineInfo?.msgContent);
        if (lineInfo.msgId) {
          setLineId(Number(lineInfo?.msgId));
        }
      }
    }
  }, [activityGroupDetail]);

  const channelData = [
    {
      sortNo: 1,
      level: 1,
      channel: formatMessage({
        id: 'marketing.people.regnotcon.c03.lbl04',
      }),
      icon: 'wechat',
      show: tenantId !== '11076',
    },
    {
      sortNo: 2,
      level: 5,
      channel: '邮件',
      icon: 'message',
      show: isMenuEmailMktg,
    },
    {
      sortNo: 3,
      level: 2,
      channel: formatMessage({
        id: 'marketing.people.regnotcon.c03.lbl06',
      }),
      icon: 'message',
      show: tenantId !== '11076',
    },
    {
      sortNo: 4,
      level: 4,
      channel: '彩信',
      icon: 'message',
      show: tenantId !== '11079' && tenantId !== '11076',
    },

    {
      sortNo: 1,
      level: 5,
      channel: 'Line 模版消息',
      icon: 'message',
      show: tenantId === '11076',
    },
  ];

  const [wechatContent, setWechatContent] = useState('');
  const [mmsContent, setMmsContent] = useState('');
  const [msgContent, setMsgContent] = useState('');
  const [emailContent, setEmailContent] = useState('');
  const [lineContent, setLineContent] = useState('');
  const [msgChecked, setMsgChecked] = useState(false);
  const [vxChecked, setVxChecked] = useState(false);
  const [mmsChecked, setMmsChecked] = useState(false);
  const [emailChecked, setEmailChecked] = useState(false);
  const [lineChecked, setLineChecked] = useState(false);
  const [msgId, setMsgId] = useState();
  const [mmsId, setMmsId] = useState();
  const [wechatId, setWechatId] = useState();
  const [emailId, setEmailId] = useState();
  const [lineId, setLineId] = useState();

  //拿到最新的值
  const handleSelectChange = (type, changes) => {
    let data = noticeChannels.concat();
    data.map((channel) => {
      if (channel.type === type.toString()) {
        channel.checked = changes.checked;
        channel.msgContent = changes.content;
        channel.msgId = changes.id;
      }
    });
    setSelectedNoticeChannels(data);
  };
  console.log('tenantId', tenantId);
  return (
    <NoticedStyled theme={theme}>
      <Box className="title">
        {formatMessage({ id: 'marketing.people.regnotcon.n05.lbl01' })}
      </Box>
      <FormLabel component="legend" className="notice-channel-title">
        {formatMessage({ id: 'marketing.people.regnotcon.n05.lbl02' })}
      </FormLabel>

      <div className="message-wrap">
        {tenantId !== '11076' && (
          <MessageML
            checked={msgChecked}
            disabled={status === 'detail'}
            // icon={'message'}
            info={msgInfoItem}
            setChecked={setMsgChecked}
            selectedId={msgId}
            setSelectedId={setMsgId}
            content={msgContent}
            setContent={setMsgContent}
            handleSelectChange={(type, changes) =>
              handleSelectChange(type, changes)
            }
            type={1}
            open={openSMS}
            setOpen={setOpenSMS}
          ></MessageML>
        )}
        {tenantId !== '11076' && (
          <MessageML
            // icon="wechat"
            disabled={status === 'detail'}
            info={wechatInfoItem}
            handleSelectChange={(type, changes) =>
              handleSelectChange(type, changes)
            }
            content={wechatContent}
            setChecked={setVxChecked}
            checked={vxChecked}
            selectedId={wechatId}
            setSelectedId={setWechatId}
            setContent={setWechatContent}
            type={2}
            open={openWechat}
            setOpen={setOpenWechat}
          ></MessageML>
        )}
        {tenantId !== '11076' && tenantId !== '11079' && (
          <MessageML
            // icon="wechat"
            disabled={status === 'detail'}
            info={mmsInfoItem}
            handleSelectChange={(type, changes) =>
              handleSelectChange(type, changes)
            }
            content={mmsContent}
            setChecked={setMmsChecked}
            checked={mmsChecked}
            selectedId={mmsId}
            setSelectedId={setMmsId}
            setContent={setMmsContent}
            type={4}
            open={openMMS}
            setOpen={setOpenMMS}
          ></MessageML>
        )}
        {isMenuEmailMktg && (
          <MessageML
            // icon="wechat"
            disabled={status === 'detail'}
            info={emailInfoItem}
            handleSelectChange={(type, changes) =>
              handleSelectChange(type, changes)
            }
            content={emailContent}
            setChecked={setEmailChecked}
            checked={emailChecked}
            selectedId={emailId}
            setSelectedId={setEmailId}
            setContent={setEmailContent}
            type={5}
            open={openEmail}
            setOpen={setOpenEmail}
          ></MessageML>
        )}
        {tenantId === '11076' && (
          <MessageML
            // icon="wechat"
            disabled={status === 'detail'}
            info={lineInfoItem}
            handleSelectChange={(type, changes) =>
              handleSelectChange(type, changes)
            }
            content={lineContent}
            setChecked={setLineChecked}
            checked={lineChecked}
            selectedId={lineId}
            setSelectedId={setLineId}
            setContent={setLineContent}
            type={6}
            open={openLine}
            setOpen={setOpenLine}
          ></MessageML>
        )}
      </div>

      <FormLabel component="legend" className="notice-channel-title">
        <span className="label-require">*</span>
        {formatMessage({ id: 'marketing.people.regnotcon.n06.lbl01' })}
      </FormLabel>
      <Controller
        control={control}
        name="noticeType"
        disabled={status === 'detail'}
        className="checkbox-radio-disabled-color"
        defaultValue="NOTICE_ONE"
        as={
          <RadioGroup
            aria-label="gender"
            control={control}
            name="noticeType"
            defaultValue="NOTICE_ONE"
            className="cycle-select-wrap"
          >
            <Box>
              <FormControlLabel
                value="NOTICE_ONE"
                control={<Radio color="primary" />}
                color="primary"
                label={formatMessage({
                  id: 'marketing.people.regnotcon.n06.rdo02',
                })}
                disabled={status === 'detail'}
                className="all-level-select"
              />
            </Box>
            <div className="notice-channel-box">
              <div className="channel-box-title">
                <span>
                  {formatMessage({
                    id: 'marketing.people.regnotcon.c03.lbl01',
                  })}
                </span>
                <span>
                  {formatMessage({
                    id: 'marketing.people.regnotcon.c03.lbl02',
                  })}
                </span>
              </div>
              {channelData &&
                channelData
                  .filter((item) => item.show)
                  .map((item, index) => {
                    return (
                      <div className="channel-box-content">
                        <span>{index + 1}</span>
                        <span>{item.channel}</span>
                      </div>
                    );
                  })}
            </div>
            <Box mt={2}>
              <FormControlLabel
                value="NOTICE_ALL"
                disabled={status === 'detail'}
                control={<Radio color="primary" />}
                color="primary"
                label={formatMessage({
                  id: 'marketing.people.regnotcon.n07.rdo01',
                })}
                className="all-level-select"
              />
            </Box>
            <div className="member-rules">
              {formatMessage({ id: 'marketing.people.regnotcon.n07.txt02' })}
            </div>
          </RadioGroup>
        }
      />
    </NoticedStyled>
  );
};
export default Noticed;
